<template>
  <div class="dashboard-pages page404" height="100% !important">
    <div class="four-0-four no-select">
      <span>4</span>
      <v-icon>error</v-icon>
      <span>4</span>
      <hr class="red" />
    </div>
    <h1>{{ $t('Oops, Section Not Found!') }}</h1>
    <h3>
      {{ $t("The part you're looking for could not be found") }}
      {{ $t('please use the sidebar links to go to a different section') }}
    </h3>
  </div>
</template>
<script>
export default {}
</script>

<style scoped>
.four-0-four {
  font-size: 12vw;
  font-family: 'roborto', Helvetica, Arial, sans-serif !important;
  color: rgb(220, 0, 0);
  text-align: center;
  text-shadow: 0 0 2px rgba(100, 0, 0, 0.5);
}
.four-0-four span {
  font-weight: 700;
  display: inline-block;
  margin-top: 10px;
}
.four-0-four .v-icon {
  position: relative;
  font-size: 12vw;
  margin-top: -50px;
  align-items: top;
  height: 13vw;
  color: rgb(220, 0, 0);
  display: inline-block;
}

h1,
h3 {
  text-align: center;
  color: rgb(220, 0, 0);
}
h3 {
  color: black;
}
</style>
